import axios from 'axios'
import { IProfileResponse } from './types'

export const accountInfoApi = {
  async getProfile(serverUrl: string, authId: string) {
    try {
      const url = serverUrl + '/api/info/profile'
      const { data } = await axios.get<IProfileResponse>(url, {
        headers: {
          'X-Auth': authId,
        },
        timeout: 5000,
      })

      return data
    } catch (error) {
      console.error('GetProfile: ', error)
      return null
    }
  },
}
